import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIn } from 'seamless-immutable';

const Suggestions = ({ page }) => {
  const data = getIn(page, ['searchSuggestions'], false);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <Title>sugestão de produtos</Title>
      <Wrapper>
        <List>
          {data.map(item => (
            <ListItem key={item.term}>
              <Link href={item.href}>{item.term}</Link>
            </ListItem>
          ))}
        </List>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 4px;
  margin: 20px 12px 0 12px;
  padding: 20px;
  overflow: hidden;
  border-bottom: 10px solid #f1f1f1;
`;

const Title = styled.h2`
  padding: 12px 0 0 10px;
  font-size: 16px;
  font-weight: bold;
  font-family: Helvetica, Arial, sans-serif;
  color: #666;
`;

const List = styled.ul`
  overflow: scroll;
  white-space: nowrap;
  &::-webkit-scrollbar {
    height: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
`;
const ListItem = styled.li`
  display: inline;
  margin-right: 20px;
`;

const Link = styled.a`
  text-decoration: underline;
  display: inline-block;
  margin-bottom: 5px;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #666;
`;

Suggestions.propTypes = {
  page: PropTypes.object,
};

export default Suggestions;
